/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Marker_Import_Close_LabelInputs */

const en_marker_import_close_label = /** @type {(inputs: Marker_Import_Close_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Close Marker Import`)
};

const fr_marker_import_close_label = /** @type {(inputs: Marker_Import_Close_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fermer l'importation des marqueurs`)
};

const de_marker_import_close_label = /** @type {(inputs: Marker_Import_Close_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schließen-Markierung importieren`)
};

const it_marker_import_close_label = /** @type {(inputs: Marker_Import_Close_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chiudi importazione marcatore`)
};

const ru_marker_import_close_label = /** @type {(inputs: Marker_Import_Close_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Закрыть Маркер Импорт`)
};

const es_marker_import_close_label = /** @type {(inputs: Marker_Import_Close_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cerrar importación de marcadores`)
};

const zh_cn2_marker_import_close_label = /** @type {(inputs: Marker_Import_Close_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`关闭标记导入`)
};

const ja_marker_import_close_label = /** @type {(inputs: Marker_Import_Close_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`マーカーのインポートを閉じる`)
};

const hi_marker_import_close_label = /** @type {(inputs: Marker_Import_Close_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`मार्कर आयात बंद करें`)
};

const pt_pt2_marker_import_close_label = /** @type {(inputs: Marker_Import_Close_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fechar Importação de Marcador`)
};

/**
* | output |
* | --- |
* | "Close Marker Import" |
*
* @param {Marker_Import_Close_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const marker_import_close_label = /** @type {((inputs?: Marker_Import_Close_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Marker_Import_Close_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_marker_import_close_label(inputs)
	if (locale === "de") return de_marker_import_close_label(inputs)
	if (locale === "it") return it_marker_import_close_label(inputs)
	if (locale === "ru") return ru_marker_import_close_label(inputs)
	if (locale === "es") return es_marker_import_close_label(inputs)
	if (locale === "zh-CN") return zh_cn2_marker_import_close_label(inputs)
	if (locale === "ja") return ja_marker_import_close_label(inputs)
	if (locale === "hi") return hi_marker_import_close_label(inputs)
	if (locale === "pt-PT") return pt_pt2_marker_import_close_label(inputs)
	return en_marker_import_close_label(inputs)
});